<template>
    <div ref="wrapper" class="wrapper" :style="wrapperStyle" style="padding-top: 30rem">
        <div ref="stickyWrapper" style="position: sticky; top: 50%; transform: translateY(-50%);">
            <div ref="overflow" class="overflow"
                style="gap: 4rem; position: relative; display: flex; object-fit: contain;">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        gsap
    } from 'gsap';

    export default {
        name: 'HorizontalSlides',
        data() {
            return {
                totalImagesWidth: 0,
            };
        },
        computed: {
            wrapperStyle() {
                if (this.totalImagesWidth && window.innerWidth) {
                    const height = (this.totalImagesWidth / window.innerWidth) * window.innerHeight;
                    return {
                        height: `${height}px`
                    };
                }
                return {};
            },
        },
        mounted() {
            this.$nextTick(() => {
                this.calculateImagesWidth();

                // Attach scroll event listener
                window.addEventListener('scroll', this.handleScroll, false);

                // Attach resize event listener
                window.addEventListener('resize', this.calculateImagesWidth, false);

                // Remove the listeners when the component is destroyed
                this.$once('hook:beforeDestroy', () => {
                    window.removeEventListener('scroll', this.handleScroll, false);
                    window.removeEventListener('resize', this.calculateImagesWidth, false);
                });
            });
        },
        methods: {
            calculateImagesWidth() {
                if (!this.$refs.overflow) return;
                const children = Array.from(this.$refs.overflow.children);

                const gap = parseFloat(window.getComputedStyle(this.$refs.overflow).gap);
                const totalGaps = gap * (children.length - 1);

                this.totalImagesWidth = children.reduce((totalWidth, child) => {
                    return totalWidth + child.offsetWidth;
                }, 0) + totalGaps;
            },

            handleScroll() {
                const wrapperTop = this.$refs.wrapper.getBoundingClientRect().top;
                const wrapperBottom = this.$refs.wrapper.getBoundingClientRect().bottom;
                const viewportHeight = window.innerHeight;
                const firstElementWidth = this.$refs.overflow.children[0].offsetWidth;

                // Dynamically get padding
                const computedStyle = window.getComputedStyle(this.$refs.wrapper);
                const paddingTop = parseFloat(computedStyle.paddingTop);
                const paddingBottom = parseFloat(computedStyle.paddingBottom);

                if (wrapperTop <= 0 && wrapperBottom >= viewportHeight) {
                    const scrollY = window.scrollY;
                    const start = this.$refs.wrapper.offsetTop + paddingTop; // Adjusted for dynamic padding
                    const end = start + this.$refs.wrapper.offsetHeight - (paddingTop + paddingBottom) -
                        viewportHeight; // Adjusted for dynamic padding

                    let progress = ((scrollY - start) / (end - start));
                    progress = Math.max(0, Math.min(progress, 1));

                    const x = ((this.totalImagesWidth - firstElementWidth) * progress) + (firstElementWidth / 2);

                    Array.from(this.$refs.overflow.children).forEach(child => {
                        gsap.to(child, {
                            x: -x + window.innerWidth / 2,
                            ease: "back.out(1.7)",
                            duration: 0.15,
                        });
                    });
                }
            },



        },
    };
</script>

<style scoped>
    .overflow {
        display: flex;
        white-space: nowrap;
        overflow-x: hidden;
        overflow-y: hidden;
    }

    .overflow > * {
        flex-shrink: 0;
    }
</style>